export class ZoneBalancingParam {
    FacilityId: string;
    CustomerId: string;
    ProductivityInput: number;
    DesiredHourlyUnits: number;    
};


// WEBPACK FOOTER //
// ./src/app/models/ZoneBalancingParam.ts